/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext } from "react";
import { PropTypes } from "prop-types";
import {
  Container,
  Item,
  List,
  Name,
  Photo,
  Remember,
  Settings,
  SettingsItem,
  SettingsList,
  SettingsSubTitle,
  Title,
  ElipseIcon,
  Topo,
  Country,
  UserPhoto,
  IconCheckContainer,
  NameContent
} from "./styles";
import Icon from "../Icon";
import { NavLink } from "react-router-dom";
import { FitinsurAPI, MessageCenter } from "utils";
import {
  GlobalAuthContext,
  GlobalLoaderContext,
  GlobalOperationContext,
} from "store/context";

const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();
const propTypes = {
  user: PropTypes.any,
};

export default function Profile({ user }) {
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  /*
  user.remember = [
      {
          nmClient: "Jhonny Roger",
          aniversaryDate: "12/10/2001"
      },
      {
          nmClient: "Vinícius Crisol",
          aniversaryDate: "12/10/2001"
      },
      {
          nmClient: "Mailson Bonito",
          aniversaryDate: "12/10/2001"
      }
  ];
*/

  const formatDate = (date) => {
    let dt = new Date(date);
    if (!dt) {
      return "";
    }
    let dtLocale = dt
      .toLocaleDateString("en", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
      .replace(",", "")
      .split(" ");

    return `${dtLocale[0]} ${dtLocale[1]}${parseInt(dtLocale[1]) === 1 ? "st" : "th"
      } ${dtLocale[2]}`;
  };

  return (
    <Container>
      <div>
        <Topo>
        <UserPhoto>
          <Icon name='user-gray' />
          <IconCheckContainer><Icon name='check-ok-green'/></IconCheckContainer>
        </UserPhoto>
        <NameContent>
          <Name>{user?.name}</Name>
          <Country>{user?.country}</Country>
        </NameContent>
        </Topo>
        <List>
          <NavLink to="/policies">
            <Item>
              <ElipseIcon name="policies" />
              <p>{user.policies}</p>
              <span>Apólices</span>
            </Item>
          </NavLink>
          {/*  <NavLink to="/claims">
          <Item>
            <ElipseIcon name="claims" />
            <p>{user.claims}</p>
            <span>Claims</span>
          </Item>
        </NavLink> */}
          <NavLink to="/enquiries">
            <Item>
              <ElipseIcon name="enquiries1" />
              <p>{user.enquiries}</p>
              <span>Cotações</span>
            </Item>
          </NavLink>
          {/*     <NavLink to="/payments">
          <Item>
            <ElipseIcon name="payments" />
            <p>{user.paymentsLate}</p>
            <span>Payments Late</span>
          </Item>
        </NavLink> */}
        </List>
        {/*      <Title>Remember</Title>
      <Remember>
        <List>
          {user.remember.map((item, index) => (
            <Item key={index}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Icon name="schedule" />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>{item.nmClient}</span>
                  <p>{formatDate(item.aniversaryDate)}</p>
                </div>
              </div>
            </Item>
          ))}
        </List>
      </Remember> */}
      </div>
      <Settings>
        <SettingsList>
          <SettingsSubTitle>Configurações</SettingsSubTitle>
          <NavLink to="/change-password">
            <SettingsItem>
              <Icon name="user" />
              Mudar Senha
            </SettingsItem>
          </NavLink>
          <NavLink to="/login">
            <SettingsItem>
              <Icon name="logout" />
              Sair
            </SettingsItem>
          </NavLink>
        </SettingsList>
      </Settings>
    </Container>
  );
}
